"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotHeadphones = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotHeadphones = _ref => {
  let {
    spotColor = "#FCB5A9",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M20.7 10.056c-.046-2.297-1.754-4.774-4.172-4.316-.13-2.183-1.878-3.481-3.868-3.71a5.7 5.7 0 0 0-3.161.587 5.46 5.46 0 0 0-2.29 2.19 8.375 8.375 0 0 0-4.291 3.667c-1.838 3.274-.93 7.956 2.858 9.19a9.227 9.227 0 0 0 3.601.297 9.147 9.147 0 0 0 3.43-1.105c.134.31.304.604.507.878a4.715 4.715 0 0 0 1.815 1.5c.377.35.851.586 1.365.677 3.123.491 5.468-1.091 6.98-3.901a3.963 3.963 0 0 0 .154-3.65 4.095 4.095 0 0 0-1.183-1.487 4.27 4.27 0 0 0-1.745-.817Z",
    opacity: 0.8
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M5 30V20a15 15 0 1 1 30 0v10m0 1.666A3.333 3.333 0 0 1 31.667 35H30a3.333 3.333 0 0 1-3.333-3.333v-5A3.333 3.333 0 0 1 30 23.333h5v8.333Zm-30 0A3.333 3.333 0 0 0 8.333 35H10a3.333 3.333 0 0 0 3.333-3.333v-5A3.333 3.333 0 0 0 10 23.333H5v8.333Z"
  }));
};
exports.SpotHeadphones = SpotHeadphones;
SpotHeadphones.displayName = "SpotHeadphones";